
import React, { useState, useEffect, useRef } from 'react';
import { useUser } from '../contexts/UserContext';
import Swal from 'sweetalert2';
import { Table, Autocomplete, TableBody, Grid, FormControlLabel, Checkbox, TableCell, TableContainer, TableRow, Paper, TableHead, Button, TablePagination, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';
import { useAccesos } from '../contexts/AccesosContext';


function TabPanel({ children, value, index }) {
    return (
        <div hidden={value !== index} style={{ marginTop: '20px' }}>
            {value === index && <Box>{children}</Box>}
        </div>
    );
}



function AddGasto ({ handleNewGasto, editGasto, idCampania, cancelarEdicion}){
     // Estado para el título, descripción y selección del ComboBox
    const server = process.env.REACT_APP_API_ROUTE;
    const key = process.env.REACT_APP_API_KEY;
    const [tituloGasto, setTituloGasto] = useState('');
    const [descripcionGasto, setDescripcionGasto] = useState('');
    const [tipoGastoSeleccionado, setTipoGastoSeleccionado] = useState(null);
    const [campania, setCampania] = useState([])
    const [monto, setMonto] = useState('');
    const [fecha, setFecha] = useState('');
    const [tipoGastos, setTipoGastos] = useState([]);
    const [modificacion, setModificacion] = useState('');
    const [IngresadoPor, setIngresadoPor] = useState('');
    const [imagePreviewUrl, setImagePreviewUrl] = useState([]);
    const [selectedImage, setSelectedImage] = useState([]);
    const fileInputRef = useRef(null);
 
    const { user } = useUser();
    const { tienePermiso } = useAccesos();
        // Obtener la fecha y hora actual
        function obtenerFechaISOsinZ() {
            const fecha = new Date();
            let fechaISO = fecha.toISOString(); // "2024-07-30T22:14:46.271Z"
            fechaISO = fechaISO.slice(0, -1); // Elimina la última posición, que es la 'Z'
            return fechaISO;
    }
 

    const fetchTiposGasto = async () => {
        try {
            const response = await fetch(`${server}/CrmTipoGastoCampaniums`);
            const data = await response.json();
            setTipoGastos(data.$values);
        } catch (error) {
            console.error('Error al cargar los Tipos de Gasto:', error);
            Swal.fire({
            icon: 'error',
            title: 'Error',
            text: 'Error al cargar los Tipos de Gasto: ' + error,
        });
        }
    }; 

    useEffect(() => {
        fetchTiposGasto();
    }, []);
    // Convertir a una cadena en formato ISO 8601
    // const fechaFormateada = obtenerFechaISOsinZ();
    // const fechaActual = new Date();
     const fechaFormateada = obtenerFechaISOsinZ();
    // Carga inicial de datos si estamos en modo edición
      useEffect(() => {
        if (editGasto && tipoGastos.length) {
          setTituloGasto(editGasto.tituloGasto);
          setDescripcionGasto(editGasto.decripcionGasto); // Cargar la descripción de la raza para editar

          const tipoGastoMatch = tipoGastos.find(e => e.id === editGasto.idTipoGasto);

          setTipoGastoSeleccionado(tipoGastoMatch || null);
          setMonto(editGasto.monto);
          setFecha(editGasto.fecha);
          setModificacion(2);
          setIngresadoPor(editGasto.ingresadoPor);
          loadGastoParaEditar(editGasto.idGasto, editGasto.idCampania);
          
      
        } else {
          setTituloGasto('');
          setDescripcionGasto(''); // Resetear la descripción si no estamos editando
          setTipoGastoSeleccionado(null);
          setMonto('');
          setFecha('');
          setModificacion(1);
          setIngresadoPor('');
      
        }
    }, [editGasto]);


        const loadGastoParaEditar = async (idGasto, idCampania) => {
            try {
                const response = await fetch(`${server}/CrmEvidenciasCampaniums/gasto/${idGasto}/campania/${idCampania}/evidencias`);
                if (response.ok) {
                    const data = await response.json();

                    const evidencias = data.$values || [];

                        const images  = evidencias.map(e => ({
                            id: e.id,
                            urlEvidencia: e.urlEvidencia,
                            file: null

                        }));

                            // e.urlEvidencia);
                        setImagePreviewUrl(images);
                        // setSelectedImage([]); // no hay archivos reales en este punto
                   
                } else {
                    const errorText = await response.text();
                    console.error("Error al obtener evidencias:", response.statusText, errorText);
                }
            } catch (error) {
                console.error("Error cargando evidencias:", error);
            }
        };

        const handleRemoveImage = async (indexEliminar) => {
            const imagenBorrar = imagePreviewUrl[indexEliminar];

            const result = await Swal.fire ({
                title: 'Estas seguro',
                text: 'Desea eliminar esta evidencia?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#d33',
                cancelButtonColor: '#3085d6',
                confirmButtonText: 'Si, eliminar',
                cancelButtonText: 'Cancelar',
            });

            if (!result.isConfirmed) return;

            if(imagenBorrar.id === 0) {
                if (imagenBorrar.urlEvidencia?.startsWith('blob:')) {
                    URL.revokeObjectURL(imagenBorrar.urlEvidencia);
                }

                setImagePreviewUrl(prev => prev.filter((_, i) => i !== indexEliminar));

                return;
            }

                try {
                    const username = ''+user.codigoUsuario+'/';

                    const response = await fetch(`${server}/CrmEvidenciasCampaniums/${imagenBorrar.id}/${username}`,{
                        method: 'DELETE'
                    });

                    if (response.ok) {
                        setImagePreviewUrl(prev => prev.filter((_, i) => i !== indexEliminar));

                        Swal.fire({
                            icon: 'success',
                            title: 'Éxito',
                            text: 'Objetivo eliminado con éxito',
                        });
                    } else {
                        const errorText = await response.text();

                        Swal.fire({
                            icon: 'error',
                            title: 'Error',
                            text: `No se pudo eliminar la imagen: ${response.statusText}`
                        });
                    }
                } catch (error) {
                    console.error('Error al eliminar el objetivo:', error);
                        Swal.fire({
                        icon: 'error',
                        title: 'Error',
                        text: 'Error al eliminar el objetivo: ' + error,
                    }); 
                }
        };

    const handleSubmit = async (e) => {
            e.preventDefault();
            const method = editGasto? 'PUT' : 'POST'; // Usar PUT para actualizar y POST para crear
            const endpoint = editGasto ? `${server}/CrmGastoCampaniums/${editGasto.idGasto}` : `${server}/CrmGastoCampaniums`;
    
            const gasto = { 
                idGasto:editGasto ? editGasto.idGasto:0,
                tituloGasto,
                decripcionGasto: descripcionGasto,
                idTipoGasto: tipoGastoSeleccionado?.id || null,
                idCampania,
                monto,
                fecha,
                IngresadoPor: !editGasto ? (user ? user.codigoUsuario : 'ADMIN               ') : IngresadoPor,
                ModificadoPor: editGasto ? (user ? user.codigoUsuario : 'ADMIN               ') : undefined,
                modificacion,
                fechaIngreso: fechaFormateada,
            
            };

            Object.keys(gasto).forEach(key => gasto[key] === undefined && delete gasto[key]);

  
            try {
                const response = await fetch(endpoint, {
                    method: method,
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(gasto),
                });
    
                if (response.ok) {
                    const text = await response.text();
                    const data = text? JSON.parse(text) : {};

                    const gastoId = editGasto
                        ? editGasto.idGasto
                        : data.idGasto || data.Id || data.id; // revisa cuál te retorna tu backend

                    const nuevas = imagePreviewUrl.filter(img => img.id === 0 && img.file);
                    
                    if (nuevas.length && gastoId) {
                        const formData = new FormData();
                        nuevas.forEach(img => formData.append('files', img.file));

                        formData.append('idCampania', idCampania);
                        formData.append('idEntidad', gastoId);
                        formData.append('tipoEntidad', 'gasto');
                        formData.append('usuario', user.codigoUsuario);
                        // formData.append('fechaIngreso', fechaFormateada);


                        await fetch(`${server}/CrmEvidenciasCampaniums/upload`, {
                            method: 'POST',
                            body: formData,
                        });

                    }


                    imagePreviewUrl.forEach(img =>{
                        if(img.urlEvidencia?.startsWith('blob:')) {
                            URL.revokeObjectURL(img.urlEvidencia);
                        }
                    });

                   setImagePreviewUrl([]);
                    if(fileInputRef.current) fileInputRef.current.value = '';

                    setTituloGasto('');
                    setDescripcionGasto(''); // Resetear la descripción si no estamos editando
                    setTipoGastoSeleccionado(null);
                    setMonto('');
                    setFecha('');
                    setModificacion(1);
                    setIngresadoPor('');
                    Swal.fire({
                        icon: 'success',
                        title: 'Operación exitosa',
                        showConfirmButton: false,
                        timer: 1500
                    });         
                    handleNewGasto();
                } else {
                    const errorData = await response.json();
                    const errorMessage = errorData.message || (errorData.errors ? Object.values(errorData.errors).flat().join(', ') : 'Ocurrió un error inesperado');
                    Swal.fire({
                        icon: 'error',
                        title: `Error ${response.status}`,
                        text: errorMessage,
                    });            }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Error al guardar el gasto',
                    text: error || 'Ocurrió un error inesperado',
                });        }
        };

    const handleCancelarEdicion = () => {
        setTituloGasto('');
        setDescripcionGasto(''); // Resetear la descripción si no estamos editando
        setTipoGastoSeleccionado(null);
        setMonto('');
        setFecha('');
        setModificacion(1);
        setIngresadoPor('');
        setImagePreviewUrl([]);
        if(fileInputRef.current) fileInputRef.current.value = '';
        if (cancelarEdicion) cancelarEdicion();
    };



    return (
        <>
        <h2>{editGasto ? 'Editar Gasto' : 'Agregar Nuevo Gasto'}</h2>
        <br />
        <form onSubmit={handleSubmit} className="form-horizontal form-label-left" >
            <div className="item form-group">
                <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="tituloGasto">
                    Título gasto: <span className="required">*</span>
                </label>
                <div className="col-md-4 col-sm-3">
                    <input
                        type="text"
                        id="tituloGasto"
                        required="required"
                        className="form-control"
                        value={tituloGasto}
                        onChange={(e) => setTituloGasto(e.target.value)}
                    />
                </div>
            </div>
            <div className="item form-group">
                <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="descripcionGasto">
                    Descripción: <span className="required">*</span>
                </label>
                <div className="col-md-4 col-sm-3">
                    <input
                        type="text"
                        id="descripcionGasto"
                        required="required"
                        className="form-control"
                        value={descripcionGasto}
                        onChange={(e) => setDescripcionGasto(e.target.value)}
                    />
                </div>
            </div>

              {/* ComboBox con Búsqueda (Autocomplete) */}
                <div className="item form-group">
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="tipoGasto">
                        Tipo de gasto: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <Autocomplete
                            options={tipoGastos}
                            getOptionLabel={(option) => option.tipoGasto}
                            value={tipoGastoSeleccionado}
                            onChange={(event, newValue) => setTipoGastoSeleccionado(newValue)}
                            renderInput={(params) => <TextField {...params} label="Opciones" />}
                            isOptionEqualToValue={(option, value) => option.label === value.label}
                            disableClearable
                        />
                    </div>
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="meta">
                        Monto: <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <input
                            type="text"
                            id="meta"
                            required="required"
                            className="form-control"
                            value={monto}
                            onChange={(e) => setMonto(e.target.value)}
                        />
                    </div>
                   
            
                </div>
                <div className="item form-group">
                    <label className="col-form-label col-md-2 col-sm-3 label-align" htmlFor="meta">
                        Fecha : <span className="required">*</span>
                    </label>
                    <div className="col-md-4 col-sm-3">
                        <input
                            type="date"
                            id="meta"
                            required="required"
                            className="form-control"
                            value={fecha}
                            onChange={(e) => setFecha(e.target.value)}
                        />
                    </div>
                </div>
                <div className="item form-group">
                    <label className="col-form-label col-md-2 col-sm-3 label-align">
                        Evidencias (imágenes):
                    </label>
                    <div className="col-md-10 col-sm-9">
                        <input
                            type="file"
                            accept="image/*"
                            multiple
                            ref={fileInputRef}
                            onChange={(e) => {
                                const files = Array.from(e.target.files);

                                const newImages = files.map(file => ({
                                    id: 0,
                                    urlEvidencia: URL.createObjectURL(file),
                                    file: file,
                                }));
                                
                                setImagePreviewUrl(prev => [...prev, ...newImages]);
                            }}
                        />
                    </div>
                </div>

                {imagePreviewUrl && imagePreviewUrl.length > 0 && (
                    <div className="form-group row mt-2">
                        {imagePreviewUrl.map((img, index) => (
                            <div key={index} className="col-md-2 mb-2 position-relative">
                                <img
                                    src={img.urlEvidencia}
                                    alt={`Evidencia ${index}`}
                                    style={{ width: '100%', height: 'auto', border: '1px solid #ccc', borderRadius: '4px' }}
                                />
                                <button
                                    type="button"
                                    onClick={() => handleRemoveImage(index)}
                                    style={{
                                        position: 'absolute',
                                        top: '2px',
                                        right: '2px',
                                        background: 'rgba(255, 0, 0, 0.7)',
                                        border: 'none',
                                        color: 'white',
                                        borderRadius: '50%',
                                        width: '24px',
                                        height: '24px',
                                        fontWeight: 'bold',
                                        cursor: 'pointer',

                                    }}
                                    title="Eliminar imagen"
                                >
                                    x
                                </button>
                            </div>
                        ))}
                    </div>
                )}

            <div className="ln_solid" />
            <div className="item form-group">
                <div className="col-md-6 col-sm-6 offset-md-3">
                    <button type="submit" className="btn btn-success" disabled={!tienePermiso('Crear Gasto CRM')}>
                        {editGasto ? 'Actualizar' : 'Guardar'}
                    </button>
                    {editGasto && (
                        <button type="button" className="btn btn-secondary" onClick={handleCancelarEdicion}>
                        Cancelar
                    </button>
                    )}
                </div>
            </div>
        </form>
    </>
    )
}


export default AddGasto;